import { NgModule } from '@angular/core';
import { EstudosFiltroPipe } from './estudos-filtro/estudos-filtro';
import { EventoFiltroPipe } from './eventos-filtro/eventos-filtro';
import { MaskPipe } from './mask/mask';
import { ProdutoFiltroPipe } from './produto-filtro/produto-filtro';
@NgModule({
	declarations: [EstudosFiltroPipe,
		EventoFiltroPipe,
		MaskPipe,
		ProdutoFiltroPipe],
	imports: [],
	exports: [EstudosFiltroPipe,
		EventoFiltroPipe,
		MaskPipe,
		ProdutoFiltroPipe]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts